import { render, staticRenderFns } from "./SectionFaq.vue?vue&type=template&id=36d59608&scoped=true&"
import script from "./SectionFaq.vue?vue&type=script&lang=ts&"
export * from "./SectionFaq.vue?vue&type=script&lang=ts&"
import style0 from "./SectionFaq.vue?vue&type=style&index=0&id=36d59608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d59608",
  null
  
)

export default component.exports